module.exports = __webpack_public_path__ + "img/281.3120db9e.jpg";